<template>
    <div
        :class="{
            container: true,
            'variant-stacked': variant === 'stacked',
            'variant-left': variant === 'left',
            'variant-right': variant === 'right',
            primary: !secondary,
            secondary: secondary
        }"
    >
        <div
            v-if="name"
            class="name"
        >
            {{ name }}<span v-if="colon">:</span>
        </div>

        <div
            v-if="$slots.default"
            class="value"
        >
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            required: false,
            default: ""
        },
        variant: {
            type: String,
            required: false,
            default: "right"
        },
        secondary: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        colon() {
            return Boolean(this.$slots.default) && !this.variant === "stacked";
        }
    }
};
</script>

<style scoped lang="scss">
$element-NamedValue-name-color: inherit !default;

.container {
    display: flex;
    flex-wrap: wrap;
}

.container .name {
    padding-right: 1rem;
    color: $element-NamedValue-name-color;
}

.primary > .name {
    font-weight: 600;
}

/* stacked */
.container.variant-stacked {
    flex-direction: column;
}

.container.variant-stacked .value {
    text-align: left !important;
    padding-left: 0;
}

/* right */
.container.variant-right {
    justify-content: space-between;
}

/* left */
.container.variant-left {
    justify-content: flex-start;
}
</style>
